module.exports = __webpack_public_path__ + "img/julian-hong.10d5da53.png";